/**
 * @class configDesktop
 *
 * Manage our configuration settings for Desktop styles.

 */

export default {
   // Application List
   appListRowHeight: 67,

   // button types
   buttonWidthLarge: 200,
   buttonWidthMedium: 150,
   buttonWidthSmall: 100,
   buttonWidthExtraSmall: 50,

   // tab types
   tabWidthLarge: 200,
   tabWidthMedium: 120,
   tabWidthSmall: 100,
   tabWidthExtraSmall: 50,

   // column types
   columnWidthXLarge: 350,
   columnWidthLarge: 250,
   columnWidthMedium: 200,
   columnWidthSmall: 150,
   columnWidthExtraSmall: 100,

   // spacers
   xSmallSpacer: 5,
   smallSpacer: 10,
   mediumSpacer: 25,
   largeSpacer: 50,
   xLargeSpacer: 100,
   xxLargeSpacer: 200,
   xxxLargeSpacer: 400,
   appListSpacerRowHeight: 100,
   appListSpacerColMinWidth: 100,
   appListSpacerColMaxWidth: 200,
   objectWorkspaceColWidth: 20,

   // labels
   labelWidthSmall: 50,
   labelWidthMedium: 80,
   labelWidthLarge: 120,
   labelWidthXLarge: 150,
   labelWidthXXLarge: 200,
   labelWidthXXXLarge: 280,
   labelWidthCheckbox: 0,

   // show elements on desktop
   hideMobile: false,
};
